import { LogoMark } from "./Ornaments";
import LanguageToggle from "./LanguageToggle";
import { useLanguage } from "@/lib/i18n";
import { useAuth } from "@/lib/AuthContext";

const SiteHeader = () => {
  const { t } = useLanguage();
  const { user, logout, authReady } = useAuth();

  return (
    <header className="suffa-header" data-testid="suffa-header">
      <a
        href="/"
        className="suffa-logo"
        data-testid="suffa-header-logo"
        aria-label="Suffa Matrimony home"
      >
        <LogoMark />
        <span className="suffa-logo-text">
          <span className="suffa-logo-name">Suffa</span>
          <span className="suffa-logo-sub">Matrimony</span>
        </span>
      </a>
      <nav className="suffa-header-nav" aria-label="Main navigation">
        <a
          href="/find-matches"
          className="suffa-nav-link"
          data-testid="suffa-header-find-matches-link"
        >
          {t("Find Matches")}
        </a>
        {authReady && user && (
          <a
            href="/my-profile"
            className="suffa-nav-link"
            data-testid="suffa-header-my-profile-link"
          >
            {t("My Profile")}
          </a>
        )}
        {authReady && user && ["admin", "super_admin"].includes(user.role) && (
          <a
            href="/admin/dashboard"
            className="suffa-nav-link"
            data-testid="suffa-header-admin-link"
          >
            {t("Admin")}
          </a>
        )}
        <LanguageToggle />
        {authReady && user ? (
          <button
            type="button"
            className="btn btn-outline btn-sm"
            data-testid="suffa-header-logout-btn"
            onClick={async () => {
              await logout();
              window.location.href = "/";
            }}
          >
            {t("Logout")}
          </button>
        ) : (
          <>
            <a href="/login" className="btn btn-outline btn-sm" data-testid="suffa-header-login-btn">
              Login
            </a>
            <a href="/register" className="btn btn-solid btn-sm" data-testid="suffa-header-register-btn">
              Register
            </a>
          </>
        )}
      </nav>
    </header>
  );
};

export default SiteHeader;
